module.exports = __webpack_public_path__ + "img/veganuaryBanner.fdb00e32.jpeg";